"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _default = (0, _immutable.Record)({
  time: null,
  busy: false,
  reason: null,
  relatedEventStartTime: null,
  ownerFirstName: null,
  ownerLastName: null,
  ownerEmail: null
}, 'TroubleshotStartTime');

exports.default = _default;
module.exports = exports.default;